module.exports = __webpack_public_path__ + "static/media/weathericons-regular-webfont.1cd48d78.woff2";